import React from "react";
import Styled from "styled-components";
function AboutHeading() {
  return (
    <MainCont>
      <OuterHead>
        About <span style={{color:"#ffb400"}}>Me</span>
      </OuterHead>
      <InnerHead>resume</InnerHead>
    </MainCont>
  );
}
const MainCont = Styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    height:25vh;
`;
const OuterHead = Styled.h1`
    color:white;
    font-size:56px;
    letter-spacing:3px;
    font-weight:1000 ;
    z-index:1;
    font-family:sans-serif;
    text-transform:uppercase;
    position:absolute;
    @media (max-width:425px){
      font-size:28px;
    }
`;
const InnerHead = Styled.span`
    color:#ffffff12;
    font-weight:1000;
    letter-spacing:10px;
    font-size:110px;
    font-family:sans-serif; 
    text-transform:uppercase;
    position:absolute;
    @media (max-width:425px){
      font-size:50px;
    }
`;
export default AboutHeading;
